import { render, staticRenderFns } from "./CreateConfigureShiftWork.vue?vue&type=template&id=de4f0400&scoped=true"
import script from "./CreateConfigureShiftWork.vue?vue&type=script&lang=js"
export * from "./CreateConfigureShiftWork.vue?vue&type=script&lang=js"
import style0 from "./CreateConfigureShiftWork.vue?vue&type=style&index=0&id=de4f0400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4f0400",
  null
  
)

export default component.exports